import computed from './computed'
import components from './components'
import resources from './resources'
import data from './data'
import methods from './methods'
import validations from './validations'
import mounted from './mounted'

export default {
  computed,
  components,
  data,
  methods,
  validations,
  mounted,

  mixins: [resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/resources/index.js